export default "__VITE_ASSET__DNG52K9v__"